import {ListDivider} from '@mui/joy';
import React from 'react';

export default function Divider() {
	return <ListDivider inset="gutter" sx={{backgroundColor: 'primary.800'}} />;
}
